import { render, staticRenderFns } from "./SimilarTopicsSideSection.vue?vue&type=template&id=a3612696"
import script from "./SimilarTopicsSideSection.vue?vue&type=script&lang=js"
export * from "./SimilarTopicsSideSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports